/* global variables dataLayer*/

import Ratsit from './ratsit';
import 'bootstrap-datepicker';
import XHR from './xhr';
var moment = require('moment');

jQuery(document).ready(function () {

    //jQuery time
    var current_fs, next_fs, previous_fs; //fieldsets
    var left, opacity, scale; //fieldset properties which we will animate
    var animating; //flag to prevent quick multi-click glitches

    $('.next').click(function(event){
        if(animating) return false;
        animating = true;

        current_fs = $(this).closest('fieldset');
        next_fs = $(this).closest('fieldset').next('fieldset');

        var form = $(this).closest('form')[0];

        if (form.checkValidity() === false) {
            form.classList.add('was-validated');
            animating = false;
            event.preventDefault();
            event.stopPropagation();
        } else {

            form.classList.add('was-validated');

            //activate next step on progressbar using the index of next_fs
            $('.progressbar li').eq($('fieldset').index(next_fs)).addClass('active');
            $('.progressbar li').eq($('fieldset').index(next_fs)).addClass('current');
            $('.progressbar li').eq($('fieldset').index(current_fs)).removeClass('current');

            current_fs.removeClass('js-fieldset-active');
            next_fs.addClass('js-fieldset-active');

            //show the next fieldset
            next_fs.show();
            //hide the current fieldset with style
            current_fs.animate({opacity: 0}, {
                step: function(now) {
                    //as the opacity of current_fs reduces to 0 - stored in "now"
                    //1. scale current_fs down to 80%
                    scale = 1 - (1 - now) * 0.2;
                    //2. bring next_fs from the right(50%)
                    left = (now * 50) + '%';
                    //3. increase opacity of next_fs to 1 as it moves in
                    opacity = 1 - now;
                    current_fs.css({
                        'transform': 'scale(' + scale + ')',
                        'position': 'absolute',
                    });
                    next_fs.css({'left': left, 'opacity': opacity});
                },
                duration: 800,
                complete: function(){
                    current_fs.hide();
                    animating = false;
                },
                //this comes from the custom easing plugin
                easing: 'easeInOutBack',
            });
        }
    });

    $('.form-check-input').on('click', function () {
        var checkboxes = document.getElementsByName('reklorsak[]');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                console.log(checkbox.name, checkbox.value);
            }
        });

        // var formData = $(this).closest('form').serialize();
    });

    $('.previous').click(function(){
        if(animating) return false;
        animating = true;

        current_fs = $(this).closest('fieldset');
        previous_fs = $(this).closest('fieldset').prev();

        //de-activate current step on progressbar
        $('.progressbar li').eq($('fieldset').index(current_fs)).removeClass('active');
        $('.progressbar li').eq($('fieldset').index(current_fs)).removeClass('current');
        $('.progressbar li').eq($('fieldset').index(previous_fs)).addClass('current');

        current_fs.removeClass('js-fieldset-active');
        previous_fs.addClass('js-fieldset-active');

        //show the previous fieldset
        previous_fs.show();
        //hide the current fieldset with style
        current_fs.animate({opacity: 0}, {
            step: function(now) {
                //as the opacity of current_fs reduces to 0 - stored in "now"
                //1. scale previous_fs from 80% to 100%
                scale = 0.8 + (1 - now) * 0.2;
                //2. take current_fs to the right(50%) - from 0%
                left = ((1-now) * 50)+'%';
                //3. increase opacity of previous_fs to 1 as it moves in
                opacity = 1 - now;
                current_fs.css({'left': left});
                previous_fs.css({'transform': 'scale('+scale+')', 'opacity': opacity});
            },
            duration: 800,
            complete: function(){
                previous_fs.css({'position': 'relative'});
                current_fs.hide();
                animating = false;
            },
            //this comes from the custom easing plugin
            easing: 'easeInOutBack',
        });
    });

	$('.submit').off('click').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('.submit').off('click');
		submitForm(this);
	});

	function submitForm(item) {
		var form = item.closest('form');

        if (form.checkValidity() === false) {
            form.classList.add('was-validated');
            animating = false;
            $('.submit').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $('.submit').off('click');
                submitForm(this);
            });
        } else {
            form.classList.add('was-validated');

            var formData = $(item).closest('.msform').find('form').serialize();
            var formName = $(item).closest('.msform').data('form');

            console.log(formData);

            var data = {
                action : 'send_multistepform',
                formData : formData,
                form : formName,
                nonce : variables.nonce,
                countrycode : document.querySelector('html').lang,
            }

            console.debug(data);

            var xhr = new XHR({
                'url' : variables.ajax_url,
                'data' : data,
            });

            xhr.send(formSuccessCallback, formErrorCallback, formName);
        }
	}

    function formSuccessCallback(response, responseId) {
        console.log(response, responseId);
        console.log(dataLayer);

        var dataLayerFormName = responseId;
        if (dataLayerFormName == 'multistepform') {
            dataLayerFormName = 'startat försäljning';
        }
        // Send data to Google Tag Manager about when sending form.
        dataLayer.push({
            'event': 'formSent',
            'formSent': 'true',
            'formName': dataLayerFormName,
        });

        console.log('Datalayer', dataLayer);

        // if (response['http_code'] == 200) {
            var forms = document.querySelectorAll('.msform');
            forms.forEach((form) => {
                if (form.dataset.form == responseId) {
                    form.closest('.flip-card').classList.add('success');
                    form.closest('.flip-card').querySelector('.checkmark').classList.add('start-animation');
                }
            });
        // }
		$('.submit').off('click').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$('.submit').off('click');
			submitForm(this);
		});
    }

    function formErrorCallback(status, id) {
        console.log(status, id);
		$('.submit').off('click').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$('.submit').off('click');
			submitForm(this);
		});
    }

    if (document.querySelector('.js-ssr-number')) {
        document.querySelector('.js-ssr-number').addEventListener('keyup', function () {
            var alert = this.closest('form').querySelector('.alert');
            var alertText = this.closest('form').querySelector('.alert .alert__text span');
            if (this.value.length == 0) {
                if (alert.style.display !== 'none') {
                    $(alert).fadeOut();
                }
            }
            if (this.value.length < 13) {
                return false;
            }

            var age = moment().diff(moment(this.value.split('-')[0], 'YYYYMMDD'), 'years')

            if (age < 18) {
                alertText.innerHTML = variables.notOldEnough;
                $(alert).fadeIn();
                document.querySelector('.js-ssr-number').setCustomValidity('Invalid');

                return false;
            }

            var fieldset = this.closest('fieldset');

            fieldset.querySelectorAll('.js-loading').forEach( (el) => {
                el.classList.add('loading');
            });

            var ratsit = new Ratsit({
                'pack' : 'personadress',
                'pnr' : this.value,
                'callbackId' : 'multistepform-ssr',
            });
            ratsit.fetch();
        });

        document.querySelectorAll('.js-ssr-number').forEach((ssr) => {
            ssr.addEventListener('keyup', function (e) {

                if (e.key !== 'Backspace' && e.key !== 'Delete') {
                    var val = this.value.replace(/\D/g, '');
                    val = val.replace(/^(\d{8})/, '$1-');
                    val = val.replace(/-(\d{4})/, '-$1');
                    this.value = val;
                }
            });
        });
    }

    if (document.querySelector('.js-corporate')) {
        document.querySelector('.js-corporate').addEventListener('keyup', function () {
            var alert = this.closest('form').querySelector('.alert');
            if (this.value.length == 0) {
                if (alert.style.display !== 'none') {
                    $(alert).fadeOut();
                }
            }

            if (this.value.length < 11) return false;

            var fieldset = this.closest('fieldset');

            fieldset.querySelectorAll('.js-loading').forEach( (el) => {
                el.classList.add('loading');
            });

            var ratsit = new Ratsit({
                'pack' : 'foretagadress',
                'pnr' : this.value,
                'callbackId' : 'multistepform-association',
            });

            ratsit.fetch();
        });

        document.querySelectorAll('.js-corporate').forEach((corporate) => {
            corporate.addEventListener('keyup', function (e) {
                if (e.key !== 'Backspace' && e.key !== 'Delete') {
                    var val = this.value.replace(/\D/g, '');
                    val = val.replace(/^(\d{6})/, '$1-');
                    val = val.replace(/-(\d{4})/, '-$1');
                    this.value = val;
                }
            });
        });
    }

    if (document.querySelector('.js-register-as')) {
        document.querySelector('.js-register-as').addEventListener('change', function () {
            const dataSelectors = {
                'Skolklass' : 'js-schoolclass',
                'Förening' : 'js-association',
                'Lag' : 'js-team',
            };

            const selectors = ['js-schoolclass', 'js-association', 'js-team'];
            this.closest('form').classList.remove('was-validated');

            selectors.forEach((selector) => {
                if (selector !== dataSelectors[this.value]) {
                    document.querySelectorAll('.' + selector).forEach((input) => {
                        input.classList.remove('is-visible');
                        input.querySelector('input').required = false;
                        input.querySelector('input').value = '';
                    });
                } else {
                    document.querySelectorAll('.' + selector).forEach((input) => {
                        input.classList.add('is-visible');
                        input.querySelector('input').required = true;
                    });
                }
            });
        });
    }

    document.addEventListener('ratsitsuccess', function (e) {
        var alertText = document.querySelector('.js-fieldset-active .alert .alert__text span');
        var alert = document.querySelector('.js-fieldset-active .alert');
        var data = checkResponse(e);

        if (e.detail.callbackId == 'multistepform-ssr') {

            if (data) {
                document.querySelector('.js-address').value = data.Street;
                document.querySelector('.js-postcode').value = data.ZipCode;
                document.querySelector('.js-city').value = data.City;
                document.querySelector('.js-firstname').value = data.firstName;
                document.querySelector('.js-lastname').value = data.lastName;
                $(alert).fadeOut();
                document.querySelector('.js-ssr-number').setCustomValidity('');
            } else {
                alertText.innerHTML = variables.notAValidSSR;
                $(alert).fadeIn();
                document.querySelector('.js-ssr-number').setCustomValidity('Invalid');
            }

            document.querySelectorAll('.loading').forEach((el) => {
                el.classList.remove('loading');
            });

        } else if (e.detail.callbackId == 'multistepform-association') {
            if (data) {
                document.querySelector('.js-association-name').value = data.companyName;
                document.querySelector('.js-association-address').value = data.Street;
                document.querySelector('.js-association-zip').value = data.ZipCode;
                document.querySelector('.js-association-city').value = data.City;
                $(alert).fadeOut();
                document.querySelector('.js-corporate').setCustomValidity('');
            } else {
                alertText.innerHTML = variables.notAValidAssNumber;
                $(alert).fadeIn();
                document.querySelector('.js-corporate').setCustomValidity('Invalid');
            }

            document.querySelectorAll('.loading').forEach((el) => {
                el.classList.remove('loading');
            });
        }
    });

    if (document.querySelector('.datepicker')) {
        document.querySelectorAll('.datepicker').forEach((picker) => {
            $(picker).datepicker({
                format: 'yyyy-mm-dd',
                language: 'sv',
                uiLibrary: 'bootstrap4',
            });
        });
    }

    function checkResponse(e) {
        let data = JSON.parse(e.detail.response);

        if (Object.keys(data).length === 0 && data.constructor === Object) {
            return false;
        } else {
            for (var key in data) {
                if (typeof data[key] === 'undefined') {
                    return false;
                }
            }
        }

        return data;
    }
});



// WEBPACK FOOTER //
// ./scripts/lib/multistepform.js